import Button from "kustom-front/src/components/atoms/Button";
import React, { FunctionComponent } from "react";

const NotFoundPage: FunctionComponent = () => {
  return (
    <div className="NotFoundPage">
      <h1>Not Found</h1>
      <p>
        <Button onClick={() => window.history.back()}>Back</Button>
      </p>
    </div>
  );
};

export default NotFoundPage;
